import * as cropsApi from "@/api/crops/index";
import store from "@/store";
import * as mt from "@/store/crops/mutation-types";
import * as notificationService from "@/services/notification";
import i18n from "@/i18n";
import { HarvestDataOverrideDTO } from "@/api/crops/types";


export async function getCropsByFarmAnalysisUuid(farmAnalysisUuid: string, 
  harvestSeason: string = "SUMMER", cropType: string | undefined = undefined) {
  try {
    const crops = (await cropsApi.getCropsByFarmAnalysisUuid(farmAnalysisUuid!, harvestSeason, cropType))
      .data;
    await store.dispatch(`crops/${mt.CROPS_REQUEST_SUCCESS}`, { uuid: farmAnalysisUuid, crops });
  } catch (err) {}
}

export async function cleanup() {
  await store.dispatch(`crops/${mt.CLEANUP}`);
}

export async function resetCrop(uuid: string) {
  await cropsApi.resetCrop(uuid);
}

/**
 * Envia a edição manual em lote dos dados de talhão (HarvestData).
 * O recálculo de scores/summary é assíncrono no backend, então os
 * controllers devem reconsultar os crops após o sucesso.
 * @returns true em caso de sucesso, false em caso de erro.
 */
export async function overrideHarvestData(
  analysisUuid: string,
  edits: HarvestDataOverrideDTO[]
): Promise<boolean> {
  try {
    await cropsApi.overrideHarvestData(analysisUuid, edits);
    notificationService.addSuccessNotification(
      i18n.t("harvest-data-editor.success") as string
    );
    return true;
  } catch (err) {
    const status = err?.response?.status;
    if (status === 409) {
      notificationService.addWarnNotification(
        i18n.t("harvest-data-editor.error-409") as string
      );
    } else if (status === 404) {
      notificationService.addErrorNotification(
        i18n.t("harvest-data-editor.error-404") as string
      );
    } else if (status === 403) {
      notificationService.addErrorNotification(
        i18n.t("harvest-data-editor.error-403") as string
      );
    } else {
      notificationService.addErrorNotification(
        i18n.t("harvest-data-editor.error-generic") as string
      );
    }
    return false;
  }
}
